<template>

  <v-container>
    <!-- Poznámky pro soutěž -->
    <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
    <!-- <div v-if="isLoadingEvent">
      <v-skeleton-loader type="chip,chip,chip,chip,chip,chip" />
      <v-row>
        <v-col cols="12" md="4" v-for="n in 3" :key="n">
          <v-skeleton-loader type="list-item-three-line, list-item-three-line, paragraph" />
        </v-col>
      </v-row>
      <v-skeleton-loader width="100%" height="40px" />
    </div> -->
    <v-card>
      <v-toolbar>
        <v-tabs v-model="main" class="flex-grow-1" bg-color="primary" slider-color="#F1A829" center-active show-arrows>
          <!-- Zachování původní záložky eventu -->
          <v-tab value="event">{{ event.event_name }}</v-tab>
          <v-divider :thickness="10" class="border-opacity-100" vertical color="tab-divider"></v-divider>
          <!-- Dynamické generování záložek pro etapy získané z API -->
          <v-tab v-for="(race, etap) in races" :key="race.id" :value="`race-${race.id}`">
            E{{ etap + 1 }}: {{ race.race_name }}
          </v-tab>
        </v-tabs>
        <!-- Zachování tlačítka nastavení -->
        <v-btn v-if="isOrganizer" :to="'/soutez/' + event.id + '/nastaveni'" style="height:100%; margin-inline-end: 0px"><v-icon size="28">mdi-cog</v-icon></v-btn>
      </v-toolbar>
      <v-window v-model="main">
        <v-window-item value="event">
          <v-alert type="info" v-if="race0.message_info">{{ race0.message_info }}</v-alert>
          <v-alert type="warning" v-if="race0.message_warning">{{ race0.message_warning }}</v-alert>

          <v-card v-if="event && event.event_organizer">
            <v-row justify="space-between">
            <!-- První sloupec -->
              <v-col cols="12" :md="files && files.length > 0 ? 3 : 6">
                <v-card-title>{{ event.event_name }} <v-chip v-if="event.canceled" prepend-icon="mdi-cancel" color="red-darken-3" variant="flat">{{ $t('event.cancelled_chip') }}</v-chip></v-card-title>
                <v-card-text class="pb-0">
                  <v-list class="event-page-race-meta-list">
                    <v-list-item>
                      <div class="d-flex align-center justify-space-between w-100">
                        <div>
                          <b>{{ $t('event.date_label') }}:</b> {{ $formatDate(event.event_date_start) }}<span v-if="event.event_date_end"> - {{ $formatDate(event.event_date_end) }}</span>
                        </div>

                        <!-- Mobile only: show Google Calendar icon aligned right -->
                        <a :href="googleCalendarUrl()" target="_blank" rel="noopener" class="ml-3" v-if="display.smAndDown">
                          <v-icon size="20" color="primary">mdi-calendar-end</v-icon>
                        </a>
                      </div>

                    </v-list-item>
                    <v-list-item>
                      <b>{{ $t('event.organizer_label') }}:</b> {{ event.event_organizer }} 
                      <v-tooltip location="top center" origin="auto" :text="$t('event.private_tooltip')">
                        <template v-slot:activator="{ props }">
                          <v-chip v-bind="props" v-if="event.visibility == 'CLUB'" prepend-icon="mdi-lock-open" color="orange-darken-1" variant="flat" size="x-small">{{ $t('event.club_visibility') }}</v-chip>
                        </template>
                      </v-tooltip>
                    </v-list-item>
                    <v-list-item>
                      <b>{{ $t('event.event_type_label') }}:</b> {{ EVENT_TYPE_DICT[event.event_type] }}
                    </v-list-item>
                    <v-list-item v-if="event.event_location">
                      <div><b>{{ $t('event.location_label') }}:</b> <a :href="`https://mapy.cz/turisticka?q=${event.event_location}`" target="_blank">{{ event.event_location }}</a></div>
                    </v-list-item>
                    <v-list-item v-if="race0.entry_deadline_1">
                      <b>{{ $t('event.entry_deadline_label') }}:</b> <span v-if="!race0.entry_deadline_2">{{ $formatDateTime(race0.entry_deadline_1) }}</span>
                      <div v-if="race0.entry_deadline_2">{{ $t('event.entry_deadline1_label') }}: {{ $formatDateTime(race0.entry_deadline_1) }}</div>
                      <div v-if="race0.entry_deadline_2">{{ $t('event.entry_deadline2_label') }}: {{ $formatDateTime(race0.entry_deadline_2) }} 
                        <v-tooltip location="top center" origin="auto" :text="$t('event.no_services_tooltip')">
                          <template v-slot:activator="{ props }">
                            <v-chip v-bind="props" v-if="event.restrict_services" size="small" color="red" variant="flat" prepend-icon="mdi-close-thick">{{ $t('event.no_services') }}</v-chip>
                          </template>
                        </v-tooltip>
                      </div>
                    </v-list-item>
                    <v-list-item v-if="event.contact">
                      <div><b>{{ $t('event.contact_label') }}:</b> {{ event.contact }}</div>
                    </v-list-item>
                    <v-list-item v-if="event.event_note">
                      <b>{{ $t('event.note_label') }}:</b> <span style="white-space: pre-wrap;">{{ event.event_note }}</span>

                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-col>

              <!-- Druhý sloupec -->
               <v-col cols="12" md="3">
                  <!-- Ikona vpravo nahoře, tooltip doleva -->
                  <div class="d-flex justify-end pr-3 ga-5 mt-3" style="width:100%; height:0px;" v-if="display.mdAndUp">
                    <v-tooltip location="left" origin="auto">
                      <template #activator="{ props }">
                        <v-icon
                          v-bind="props"
                          size="40"
                          color="primary"
                          @click="copyPageUrl"
                        >
                          mdi-link
                        </v-icon>
                      </template>
                      {{ $t('event_settings.stage.tooltip_url') }}
                    </v-tooltip>
                    <v-tooltip :text="$t('home.google')" location="top" origin="auto">
                      <template #activator="{ props }">
                        <a v-bind="props" :href="googleCalendarUrl()" target="_blank" rel="noopener">
                          <v-icon 
                            size="35" 
                            color="primary"
                            >
                            mdi-calendar-end
                          </v-icon>
                        </a>
                      </template>
                    </v-tooltip>

                  </div>
                  <div class="d-flex flex-column align-center fill-height" style="margin-top:-10px">
                    <div class="flex-grow-1 d-flex flex-column align-center justify-center w-100">
                      <div v-if="event.entry_is_open && !isDeadlinePassed" class="w-100 text-center">
                          <!-- Zkontroluj, zda je uživatel již přihlášen -->
                          <div v-if="userHasEntry && authStore.isLoggedIn" class="text-center">
                          <v-btn 
                            text color="info"
                            class="pa-3 my-1 text-center"
                            width="100%"
                            height="100%"
                            style="line-height: 25px;"
                            :to="'/soutez/' + event.id + '/prihlaska/'">
                            {{ $t('event.edit_entry') }}
                          </v-btn>
                          <p>{{ $t('event.until_label') }} {{ currentDeadline }} <br> <span :class="{'text-red': deadlineTerm === '2. termín'}">{{ deadlineTerm }}</span><br><span v-if="showNoEditNotice" class="text-caption">{{ $t('event.until_label_alert') }}</span></p>
                        </div>
                        <div v-else class="text-center">
                          <v-btn
                            text color="success"
                            class="pa-3 my-1 text-center"
                            width="100%"
                            height="100%"
                            style="line-height: 25px;"
                            :to="'/soutez/' + event.id + '/prihlaska/'">
                            {{ $t('event.register') }}
                          </v-btn>
                          <p>{{ $t('event.until_label') }} {{ currentDeadline }} <br> <span :class="{'text-red': deadlineTerm === '2. termín'}">{{ deadlineTerm }}</span></p>

                          <EventPageAbsences
                            v-if="authStore.isLoggedIn
                              && ['REPRE','SCM','MASTERS'].includes((event.event_type || '').toUpperCase())
                              && authStore.availableIndexes.some(i =>
                                ['RCZ','SCM','MASTERS'].includes((i || '').slice(0,3).toUpperCase())
                              )
                            "
                          />
                        </div>
                      </div>

                      <div v-if="event.entry_is_open && isDeadlinePassed" class="w-100 text-center">
                        <v-alert type="info">{{ currentDeadline }}</v-alert>
                        <v-btn
                          v-if="userHasEntry && authStore.isLoggedIn"
                          text color="primary"
                          class="pa-3 my-1 text-center"
                          width="100%"
                          height="50%"
                          style="line-height: 25px;"
                          :to="'/soutez/' + event.id + '/prihlaska/'">
                          {{ $t('event.my_entry') }}
                        </v-btn>
                      </div>
                      
                      <div v-if="!event.entry_is_open" class="w-100 text-center">
                        <v-alert type="info">{{ $t('event.entry_not_started') }}</v-alert>
                      </div>
                    </div>

                    <div v-if="event.user_is_delegate" class="w-100 text-center mt-auto pb-2">
                      <v-btn
                        color="secondary"
                        :loading="loadingDelegateReport"
                        :href="`${BaseUrl}/export/?type=docx&name=delegate_report&event_id=${event.id}`"
                        @click="downloadDelegateReport"
                      >
                        {{ $t('event.download_delegate_report') }}
                      </v-btn>
                    </div>
                </div>
              </v-col>

              <!-- Třetí sloupec -->
              <v-col cols="12" md="3" v-if="files && files.length > 0">
                <v-card v-if="filesWithLocation.length > 0" class="elevation-2">
                <v-card-title>{{ $t('event.files_title') }}: </v-card-title>
                <v-card-text>
                  <v-list v-for="file in filesWithLocation" :key="file.id">           
                      <v-list-item-title>
                        <a :href="`${BaseUrl}${file.location}`" target="_blank" class="font-weight-bold">{{ file.name }}</a>
                      </v-list-item-title>
                  </v-list>
                </v-card-text>
                </v-card>

                <v-card class="mt-2 elevation-2" v-if="filesWithLinks.length > 0">
                  <v-card-title>{{ $t('event.links_title') }}: </v-card-title>
                  <v-card-text>
                    <v-list v-for="file in filesWithLinks" :key="file.id">           
                      <v-list-item-title>
                        <a :href="file.url" target="_blank" class="font-weight-bold">{{ file.name }}</a>
                      </v-list-item-title>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Čtvrtý sloupec MAPA -->

              <v-col cols="12" md="3">

                <EventPageLocationMap :isOrganizer="isOrganizer" @touchstart.stop
                   />

              </v-col>
            
            </v-row>
          </v-card>
        </v-window-item>

        <!-- Dynamické generování obsahu pro etapy -->
        <v-window-item v-for="(race, etap) in races" :key="race.race" :value="`race-${race.id}`">
          <v-alert type="info" v-if="race.message_info">{{ race.message_info }}</v-alert>
          <v-alert type="warning" v-if="race.message_warning">{{ race.message_warning }}</v-alert>

            <v-row>
              <v-col cols="12" md="9" class="">
                <v-card-title>Etapa {{ etap + 1 }}: {{ race.race_name }}</v-card-title>
                <v-card-text>
                  <v-list class="event-page-race-meta-list">
                    <v-list-item>
                      <b>ID:</b> {{ race.id }}
                    </v-list-item>
                    <v-list-item>
                      <b>{{ $t('event.race_date_label') }}:</b> {{ $formatDate(race.race_date) }}
                    </v-list-item>
                    <v-list-item>
                      <b>{{ $t('event.race_level_label') }}:</b> {{ RACE_LEVEL_DICT[race.race_level] }}
                    </v-list-item>
                    <v-list-item v-if="race.race_type">
                      <b>{{ $t('event.race_type_label') }}:</b> {{ RACE_TYPE_DICT[race.race_type] }}
                    </v-list-item>
                    <v-list-item v-if="race.race_band">
                      <b>{{ $t('event.band_label') }}:</b> {{race.race_band }}
                    </v-list-item>
                    <v-list-item v-if="race.race_start">
                      <b>Start 00:</b> {{ $formatTime(race.race_start) }}
                    </v-list-item>
                    <v-list-item v-if="race.race_time_limit">
                      <b>{{ $t('event.time_limit_label') }}:</b> {{ race.race_time_limit }} {{ $t('event.time_limit_unit') }}
                    </v-list-item>
                    <v-list-item v-if="race.race_note">
                      <b>{{ $t('event.note_label') }}:</b> <span style="white-space: pre-wrap;">{{ race.race_note }}</span>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-col>

              <!-- Druhý sloupec -->
              <v-col cols="12" md="3" v-if="files && files.length > 0">
                <v-card v-if="filesWithLocation.length > 0" class="elevation-2">
                <v-card-title>{{ $t('event.files_title') }} </v-card-title>
                <v-card-text>
                  <v-list v-for="file in filesWithLocation" :key="file.id">           
                      <v-list-item-title>
                        <a :href="`${BaseUrl}${file.location}`" target="_blank" class="font-weight-bold">{{ file.name }}</a>
                      </v-list-item-title>
                  </v-list>
                </v-card-text>
                </v-card>

                <v-card class="mt-2 elevation-2" v-if="filesWithLinks.length > 0">
                  <v-card-title>{{ $t('event.links_title') }} </v-card-title>
                  <v-card-text>
                    <v-list v-for="file in filesWithLinks" :key="file.id">           
                      <v-list-item-title>
                        <a :href="file.url" target="_blank" class="font-weight-bold">{{ file.name }}</a>
                      </v-list-item-title>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
          
            </v-row>
        </v-window-item>

      </v-window>

      <!-- Další záložky, které jsou pro celý event -->

      <v-tabs v-model="second" bg-color="primary" fixed-tabs slider-color="#F1A829" class="mt-2">

        <v-tab value="automodule" v-if="isRace0 && authStore.isLoggedIn && !event.disable_automodule">{{ $t('event.automodule_tab') }}</v-tab>
        <v-tab value="entries" v-if="isRace0 && entries.length > 0">{{ $t('event.entries') }}</v-tab>
        <v-tab value="payments" v-if="isRace0 && entries.length > 0 && authStore.isLoggedIn">{{ $t('event.payments') }}</v-tab>
        <v-tab value="startlist" v-if="!isRace0 && startlist.length > 0">{{ $t('event.startlist') }}</v-tab>
        <v-tab value="results" v-if="!isRace0 && results.length > 0">{{ $t('event.results') }}</v-tab>


      </v-tabs>
      <v-card-text class="px-0">
        <v-window v-model="second" disabled>
      

              <!-- **********************************
     **************************************
     ********   Seznam Automodule    ******
     **************************************
     ************************************** -->


          <v-window-item value="automodule" v-if="isRace0 & authStore.isLoggedIn && !event.disable_automodule">
            <v-card-text class="pt-0">
              <!-- Zobrazení úspěšné nebo chybové zprávy -->
              <v-alert type="error" v-if="errorMessageAutomodule">{{ errorMessageAutomodule }}</v-alert>

              <v-btn color="primary" @click="toggleShowAll">{{ showAllModules ? $t('event.automodule.show_club') : $t('event.automodule.show_all') }}</v-btn>
              <v-progress-circular v-if="allAutomoduleLoading" indeterminate color="primary"></v-progress-circular>

              <!-- Ikona pro vytvoření nového Automodule -->
              <v-icon @click="openCreateAutomoduleDialog" color="green" class="mt-2" size="45" style="float:right" :title="$t('event.automodule.add_car_title')">mdi-car</v-icon>


              <v-col cols="12">
                <b>{{ $t('event.automodule.no_transport') }}&nbsp;</b>
                <span v-if="filteredEntries.length > 0">
                  <span v-for="(entry, index) in filteredEntries" :key="entry.id">
                    {{ entry.last_name }} {{ entry.first_name }}<span v-if="entry.wayNotice"> ({{ entry.wayNotice }})</span><span v-if="index < filteredEntries.length - 1">, </span>
                  </span>
                </span>
                <span v-else style="color:green">
                  {{ $t('event.automodule.all_have_transport') }}
                </span>
              </v-col>
              
            </v-card-text>


            <!-- Dialog pro vytvoření Automodule -->
            <v-dialog v-model="dialogCreateAutomodule" persistent max-width="400px">
              <v-card>
                <v-card-title class="text-h5">{{ $t('event.automodule.dialog_create_title') }}</v-card-title>
                <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
                <v-card-text>
                  <v-form @submit.prevent="submitAutomodule">
                    <v-text-field
                      v-model="title"
                      :label="$t('event.automodule.form_departure_label')"
                      maxlength="80"
                    ></v-text-field>
                    <v-text-field
                      v-model="maxEntries"
                      :label="$t('event.automodule.form_seats_label')"
                      type="number"
                      :rules="[v => v > 0 && v <= 50 || $t('event.automodule.form_seats_rule')]"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialogCreateAutomodule = false">{{ $t('event.automodule.form_cancel') }}</v-btn>
                  <v-btn color="green darken-1" :disabled="!isFormValid" text @click="submitAutomodule">{{ $t('event.automodule.form_create') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-row>
              <v-col v-for="automodule in automodules" :key="automodule.id" cols="12" md="6">
                <v-card elevation="3">
                  <v-card-title>
                    <v-row>
                      <v-col>
                        {{ automodule.club_shortcut }}
                        <a :href="`${BaseApiUrl}/automodule/?automodule_id=${automodule.id}`" target="_blank" v-if="canEditAutomodule(automodule)">
                          <v-icon color="success" :title="$t('event.automodule.download_xlsx')">
                            mdi-microsoft-excel
                          </v-icon>
                        </a>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col style="flex-grow: 0;" v-if="!automodule.close">
                        <v-icon
                          v-if="!isEditing || automodule.editing"
                          color="blue"
                          @click="toggleEditAutomodule(automodule)"
                          v-show="canEditAutomodule(automodule)"
                        >
                          {{ automodule.editing ? 'mdi-content-save' : 'mdi-pencil' }}
                        </v-icon>
                        <v-icon
                        v-if="automodule.editing"
                          color="grey"
                          @click="automodule.editing = false"
                          :title="$t('event.automodule.back_button')"
                        >
                          mdi-arrow-u-left-top
                        </v-icon>
                        <v-icon
                          v-if="!isEditing || automodule.editing"
                          color="red"
                          @click="automodule.dialogDeleteAutomodule = true"
                          v-show="canEditAutomodule(automodule)"
                        >
                          mdi-delete
                        </v-icon>
                      </v-col>
                      <v-col style="flex-grow: 0;" v-if="automodule.close" v-show="canEditAutomodule(automodule)">
                        <v-tooltip location="top center" origin="auto">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              color="grey"
                              v-bind="props"
                            >
                              mdi-lock
                            </v-icon>
                          </template>
                          <span>{{ $t('event.automodule.locked_tooltip', { date: $formatDate(automodule.close_date) }) }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-title class="py-0" style="white-space: normal;">
                    <span v-if="!automodule.editing" v-html="linkify(automodule.title)"></span>
                    <v-text-field
                      v-if="automodule.editing"
                      v-model="automodule.title"
                      :label="$t('event.automodule.form_departure_label')"
                      density="comfortable"
                      maxlength="80"
                      :rules="[value => !!value || $t('rule.required')]"
                    ></v-text-field>
                  </v-card-title>
                  <v-card-subtitle style="white-space: normal;">
                    <span v-if="!automodule.editing" v-html="linkify(automodule.notice)"></span>
                  </v-card-subtitle>
                  <v-row v-if="automodule.editing">
                    <v-col cols="12" md="9" class="py-0">
                      <v-text-field
                        v-model="automodule.notice"
                        :label="$t('event.automodule.note_label')"
                        maxlength="100"
                        density="comfortable"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                      <v-text-field
                        v-model="automodule.max_entries"
                        :label="$t('event.automodule.form_seats_label')"
                        type="number"
                        :rules="[v => v > 0 && v <= 50 || $t('event.automodule.form_seats_rule', { min: 1, max: 50 })]"
                        density="comfortable"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="automodule.editing">
                    <v-col cols="12" md="4" class="pt-0">
                      <v-text-field
                        v-model="automodule.date_there"
                        :label="$t('event.automodule.there_date_label')"
                        type="date"
                        density="comfortable"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5" class="pt-0">
                      <v-text-field
                        v-model="automodule.place_there"
                        :label="$t('event.automodule.there_place_label')"
                        density="comfortable"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field
                        v-model="automodule.km_there"
                        type="number"
                        :label="$t('event.automodule.there_km_label')"
                        density="comfortable"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="automodule.editing">
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="automodule.date_back"
                        :label="$t('event.automodule.back_date_label')"
                        type="date"
                        density="comfortable"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="automodule.place_back"
                        :label="$t('event.automodule.back_place_label')"
                        density="comfortable"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="automodule.km_back"
                        type="number"
                        :label="$t('event.automodule.back_km_label')"
                        density="comfortable"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-list density="compact" class="event-automodule-entry-list">
                    <v-list-item v-for="(entry, index) in automodule.entries" :key="entry.id" class="py-0">
                      <v-row class="ma-0 py-0" align="center">
                        <v-col class="py-0" style="display: flex; align-items: center;">
                          <v-icon v-if="index === 0" class="mr-2">mdi-steering</v-icon>
                          <v-tooltip v-else-if="!entry.editing" location="top center" origin="auto" :text="getTooltipText(entry.way)">
                            <template v-slot:activator="{ props }">
                              <v-icon v-bind="props" class="mr-2">{{ getIconClass(entry.way) }}</v-icon>
                            </template>
                          </v-tooltip>
                          <v-icon v-else @click="toggleWay(entry)" class="mr-2">{{ getIconClass(entry.way) }}</v-icon>
                          <span :class="{'grey--text': !entry.name}" v-if="!entry.editing" :style="{ minWidth: maxEntryNameWidth + 'px' }">
                            <b>{{ entry.name || $t('event.automodule.list_free_spot') }}
                              <v-tooltip location="top center" origin="auto" :text="$t('event.automodule.not_club_member_tip')">
                                <template v-slot:activator="{ props }">
                                  <v-icon v-bind="props" v-if="entry.name && entry.club_shortcut != automodule.club_shortcut"  color="red darken-1">mdi-map-marker-alert</v-icon>
                                </template>
                              </v-tooltip>
                            </b>
                          </span>
                          <span v-if="!entry.editing">{{ entry.notice || '' }}</span>
                          <v-combobox
                            v-if="entry.editing"
                            v-model="entry.name"
                            :items="filteredEntries.map(e => `${e.last_name} ${e.first_name}`)"
                            :label="$t('event.automodule.person_label')"
                            density="comfortable"
                            clearable
                            hide-details
                            class="flex-grow-1 pr-2"
                            style="min-width:200px; flex:1"
                            no-data-text="event.automodule.no_data_text"
                          ></v-combobox>

                          <v-text-field
                            v-if="entry.editing"
                            v-model="entry.notice"
                            :label="$t('event.automodule.note_label')"
                            density="comfortable"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="py-0" style="flex-grow: 0;">
                        <v-icon
                          color="blue"
                          v-if="!automodule.close"
                          @click="toggleEditEntry(entry, automodule)"
                          v-show="entry.editing || canEditEntry(entry, automodule) && !isEditingEntryOtherThan(entry)"
                        >
                          {{ entry.editing ? 'mdi-content-save' : 'mdi-pencil' }}
                        </v-icon>
                        <v-icon 
                        color="grey" 
                        v-else 
                        v-show="entry.editing || canEditEntry(entry, automodule) && !isEditingEntryOtherThan(entry)"
                        > mdi-lock
                        </v-icon>
                        <v-icon
                          v-if="entry.editing"
                          color="grey"
                          @click="cancelEditEntry(entry)"
                          :title="$t('event.automodule.back_button')"
                        >
                          mdi-arrow-u-left-top
                        </v-icon>
                      </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-card>


                <!-- Dialog pro potvrzení smazání Automodule -->
                <v-dialog v-model="automodule.dialogDeleteAutomodule" persistent max-width="600px" class="dialog-over-dialog">
                  <v-card>
                    <v-card-title class="text-h5">{{ $t('event.automodule.delete_confirm_title') }}</v-card-title>
                    <v-card-text>{{ $t('event.automodule.delete_confirm_text')}} {{ automodule.title }}</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="automodule.dialogDeleteAutomodule = false">{{ $t('event.automodule.delete_cancel') }}</v-btn>
                      <v-btn color="red darken-1" text @click="confirmDeleteAutomodule(automodule)">{{ $t('event.automodule.delete_confirm') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>









          </v-window-item>


              <!-- **********************************
              **************************************
              *******   Seznam přihlášených   ******
              **************************************
              ************************************** -->

          <v-col cols="12" md="8" class="mx-auto" v-if="isLoadingEntries">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-col>

          <v-window-item value="entries" v-if="entries.length > 0 && isRace0">
              <v-row class="justify-space-between"> 
                <v-col cols="6" md="3" class="d-flex justify-center" v-if="authStore.isLoggedIn"> <!-- v-if="isClubManager" dočasně oddělán -->
                  <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ props }">
                      <v-btn color="green" text v-bind="props">
                        {{ $t('event.entries_view.export') }} <v-icon right>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :href="`${BaseUrl}/export/?type=xlsx&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event.entries_view.export_xlsx') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_matula&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event_settings.entries.csv_matula') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_ardf_manager&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event_settings.entries.csv_ardf_manager') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_ocm&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event_settings.entries.csv_ocm') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_fjww&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event_settings.entries.csv_fjww') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=xml&name=entry_xml&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event_settings.entries.ardf_xml') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=json&name=entry_json&event_id=${event.id}`">
                        <v-list-item-title>{{ $t('event_settings.entries.ardf_json') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=si_droid_race&race_id=${currentRaceId}`">
                        <v-list-item-title>{{ $t('event_settings.startlist.export.si_droid') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col cols="6" md="2" class="d-flex justify-center" v-if="authStore.isLoggedIn && isClubManager &&
                      authStore.availableIndexes.some(i =>
                        (
                          i.slice(0,3).toUpperCase() === 'RCZ' && event.event_type.toUpperCase() === 'REPRE'
                        ) || (
                          i.slice(0,3).toUpperCase() === 'SCM' && event.event_type.toUpperCase() === 'SCM'
                        ) || (
                          i.slice(0,3).toUpperCase() === 'MASTERS' && event.event_type.toUpperCase() === 'MASTERS'
                        )
                      )
                      ">
                  <EventPageAbsencesListAll
                    :event-type="event.event_type"
                  />
                </v-col>
                <v-col cols="12" md="3" class="d-flex justify-center">
                  <v-btn color="primary" @click="toggleViewMode">
                  {{ viewMode === 'category' ? $t('event.entries_view.toggle_to_club') : $t('event.entries_view.toggle_to_category') }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="isClubManager" class="d-flex justify-center">
                  <v-tooltip location="top center" origin="auto" :text="$t('event.entries_view.copy_emails_tooltip')">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" color="primary" @click="copyEmails">{{ $t('event.entries_view.copy_emails') }}</v-btn>
                    </template>
                  </v-tooltip>  
                </v-col>
              </v-row>



            <!-- Menu pro zkopírování emailů členů z oddílu -->
            <!-- <v-menu v-if="isClubManager" offset-y transition="slide-y-transition">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" text v-bind="props">
                  Zkopírovat emaily <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="copyEmails">
                  <v-list-item-title>Přihlášených</v-list-item-title>
                </v-list-item>
                <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_matula&event_id=${event.id}`">
                  <v-list-item-title>Nepřihlášených</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            
            <v-row v-if="viewMode === 'category'">

              <!-- Navigační lišta kategorií -->
              <v-row class="w-100" justify="center">
                <v-col cols="12" class="ma-1 text-center">
                  <v-btn
                    v-for="(categoryName, index) in Object.keys(sortedEntriesByCategory)"
                    :key="index"
                    @click="scrollToCategory(categoryName)"
                    text
                    :color="getCategoryButtonColor(categoryName)"
                    class="ma-1"
                  >
                    {{ categoryName }}
                  </v-btn>
                </v-col>
              </v-row>

            <v-col col="12" md="8" v-for="(categoryEntries, categoryName) in sortedEntriesByCategory" :key="categoryName" :id="`category-${categoryName.replace(/\s+/g, '-')}`" class="mx-auto px-2">

              <v-card-title>{{ categoryName }} ({{ categoryEntries.length }})</v-card-title>
                <v-data-table
                  :headers="categoryEntriesHeaders"
                  :items="categoryEntries"
                  :items-per-page="-1"
                  @touchstart.stop
                  @touchmove.stop
                  :sort-by="EntrySortByName"
                  density="comfortable"
                  class="elevation-2"
                  striped="even"
                  hover
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td style="white-space: nowrap;">
                        <router-link v-if="item.account_id" :to="'/ucet/' + item.account_id">
                          {{ item.last_name }} {{ item.first_name }}
                        </router-link>
                        <template v-else>
                          {{ item.last_name }} {{ item.first_name }} <!--Pokud uživatel nemá v robisu účet, neukáže se na něj odkaz-->
                        </template>
                      </td>
                      <td v-if="isRepreOrScm">{{ item.connected_with }}</td>
                      <td>{{ item.competitor_index }}</td>
                      <td>{{ item.si_number }}</td>

                      <td v-for="race in races" :key="race.id">
                        {{ item.raceCategories && item.raceCategories[`race_${race.id}`] ? item.raceCategories[`race_${race.id}`] : '---' }}
                      </td>
                      
                    </tr>
                  </template>
                  <template v-slot:bottom></template>
                </v-data-table>
              </v-col>
              </v-row>
              <v-row v-else>

                <!-- Navigační lišta oddílů -->
                  <v-row class="w-100" justify="center">
                    <v-col cols="12" class="ma-1 text-center">
                      <v-btn
                        v-for="(clubName, index) in Object.keys(sortedEntriesByClub)"
                        :key="index"
                        @click="scrollToClub(clubName)"
                        text
                        class="ma-1"
                      >
                        {{ clubName }}
                      </v-btn>
                    </v-col>
                  </v-row>

                <v-col col="12" md="8" v-for="(clubEntries, clubName) in sortedEntriesByClub" :key="clubName" :id="`club-${clubName.replace(/\s+/g, '-')}`" class="mx-auto px-2">
                  <v-card-title>{{ clubName }} ({{ clubEntries.length }})</v-card-title>
                  <v-data-table
                    :headers="ClubEntriesHeaders"
                    :items="clubEntries"
                    :items-per-page="-1"
                    class="elevation-1"
                    @touchstart.stop
                    @touchmove.stop
                    :sort-by="EntrySortByCategory"
                    striped="even"
                    hover
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td style="white-space: nowrap;">
                          <router-link v-if="item.account_id" :to="'/ucet/' + item.account_id">
                            {{ item.last_name }} {{ item.first_name }}
                          </router-link>
                          <template v-else>
                            {{ item.last_name }} {{ item.first_name }} <!--Pokud uživatel nemá v robisu účet, neukáže se na něj odkaz-->
                          </template>
                        </td>
                        <td>{{ item.category_name }}</td>
                        <td>{{ item.competitor_index }}</td>
                        <td>{{ item.si_number }}</td>

                        <td v-for="(race) in races" :key="race.id">
                          {{ item.raceCategories && item.raceCategories[`race_${race.id}`] ? item.raceCategories[`race_${race.id}`] : '---' }}
                        </td>

                      </tr>
                    </template>
                    <template v-slot:bottom></template>
                  </v-data-table>
                </v-col>
              </v-row>

          </v-window-item>


          <!-- **********************************
              **************************************
              *******   Přehled plateb   ******
              **************************************
              ************************************** -->


          <v-window-item value="payments" v-if="entries.length > 0 && isRace0">
            <div class="d-flex justify-end mr-4" style="margin-bottom:-40px">
                      <v-btn 
                        color="green" 
                        :href="`${BaseUrl}/export/?type=xlsx&event_id=${event.id}`"
                        :loading="isDownloadingFile"
                        @click="downloadFile"
                      >
                        {{ $t('event.payments_view.download_table') }}&nbsp;&nbsp;<v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
            </div>
                    
                

            <PaymentTable 
              :payment="payments" 
            />


          </v-window-item>



              <!-- **********************************
              **************************************
              ***********     Startovky    *********
              **************************************
              ************************************** -->


          <v-col cols="12" md="8" class="mx-auto" v-if="isLoadingStartlist && !isRace0 && !startlist.length == []">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-col>


          <v-window-item value="startlist" v-if="!isLoadingStartlist && startlist.length > 0 && !isRace0">
                       
            <v-row class="align-center justify-center mb-2">
              <v-col cols="7" md="4" class="d-flex justify-center align-center px-2">
                <v-btn
                  color="primary"
                  class="text-wrap px-2"
                  @click="toggleStartlistViewMode"
                >
                  {{ startlistViewMode === 'category' ? $t('event.startlist_view.toggle_to_time') : $t('event.startlist_view.toggle_to_category') }}
                </v-btn>
              </v-col>
              <v-col cols="2" md="4" class="d-flex justify-center align-center px-2" v-if="authStore.isLoggedIn">
                <v-menu offset-y transition="slide-y-transition">
                  <template #activator="{ props }">
                    <v-btn icon v-bind="props" title="Export startovky" color="primary">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="exportStartlistTxt">
                      <v-list-item-title>{{ $t('event.startlist_view.txt') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=pdf&name=startlist_starter&race_id=${currentRaceId}`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.starter') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=pdf&name=startlist_clubs&race_id=${currentRaceId}`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.clubs') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseApiUrl}/?type=json&name=race&race_id=${currentRaceId}&dl=1`" :download="`race_${currentRaceId}.json`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.json_ardf') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=csv&name=startlist&race_id=${currentRaceId}`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.csv') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=xml&name=startlist&race_id=${currentRaceId}`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.xml') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=xml&name=startlist&race_id=${currentRaceId}`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.o_checklist') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col cols="2" md="4" class="d-flex justify-center align-center px-2" v-if="authStore.isLoggedIn">
                <v-btn
                  icon
                  :title="$t('event.startlist_view.print_menu_title')"
                  color="primary"
                  @click="printElementById('startlistContent', { title: $t('event.startlist'), headerLines: exportRaceHeaderLines })"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <!-- Navigační lišta kategorií mimo tisknutý obsah -->
            <v-row v-if="startlistViewMode === 'category'" class="w-100" justify="center">
              <v-col cols="12" class="ma-1 text-center">
                <v-btn
                  v-for="(categoryName, index) in Object.keys(sortedStartlistByCategory)"
                  :key="index"
                  @click="scrollToStartlistCategory(categoryName)"
                  text
                  :color="getCategoryButtonColor(categoryName)"
                  class="ma-1"
                >
                  {{ categoryName }}
                </v-btn>
              </v-col>
            </v-row>

            <div id="startlistContent">
            <!-- Zobrazení podle katogorií -->
            <v-row v-if="startlistViewMode === 'category'">

              <v-col col="12" md="8" v-for="(categoryEntries, categoryName) in sortedStartlistByCategory" :key="categoryName" :id="`startlist-category-${categoryName.replace(/\s+/g, '-')}`" class="mx-auto pt-1 px-2">
                <v-card-title>{{ categoryName }} ({{ categoryEntries.length }})</v-card-title>
                  <v-data-table
                    :headers="GetStartlistHeaders"
                    :items="categoryEntries"
                    :items-per-page="-1"
                    class="elevation-2"
                    @touchstart.stop
                    @touchmove.stop
                    :sort-by="sortBy"
                    density="compact"
                    striped="even"
                    hover
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>{{ $formatTimeSec(item.competitor_start_time) }}</td>
                        <td style="white-space: nowrap;">{{ item.full_name }}</td>
                        <td>{{ item.start_number }}</td>
                        <td>{{ item.si_number }}</td>
                        <td>{{ item.club_shortcut }}</td>
                      </tr>
                    </template>
                    <template v-slot:bottom></template>
                  </v-data-table>
              </v-col>
            </v-row>

            <!-- Zobrazení podle startovních časů -->
            <v-row v-else>
              <!-- Popisný řádek nad sloupci (zobrazen pouze jednou nahoře) -->
              <v-col col="12" md="8" class="mx-auto py-1">
                <div class="startlist-header-row">
                  <div class="startlist-header-cell">{{ $t('event.startlist_view.headers_full_name') }}</div>
                  <div class="startlist-header-cell">{{ $t('event.startlist_view.headers_start_number') }}</div>
                  <div class="startlist-header-cell">{{ $t('event.startlist_view.headers_category') }}</div>
                  <div class="startlist-header-cell">{{ $t('event.startlist_view.headers_si') }}</div>
                  <div class="startlist-header-cell">{{ $t('event.startlist_view.headers_club') }}</div>
                </div>
              </v-col>

              <!-- Výčet startlistu -->
              <v-col col="12" md="8" v-for="(timeEntries, startTime) in sortedStartlistByTime" :key="startTime" style="border-bottom: 1px solid #000;" class="mx-auto px-4">
                <v-card-title class="print-time-title">{{ $formatTimeSec(startTime) }}</v-card-title>
                  <div v-for="item in timeEntries" :key="item.index" class="startlist-item">
                    <div class="startlist-row">
                      <div class="startlist-cell">{{ item.full_name }}</div>
                      <div class="startlist-cell">{{ item.start_number }}</div>
                      <div class="startlist-cell">{{ item.category_name }}</div>
                      <div class="startlist-cell">{{ item.si_number }}</div>
                      <div class="startlist-cell">{{ item.club_shortcut }}</div>
                    </div>
                  </div>
              </v-col>
            </v-row>
          </div>
          </v-window-item>


    <!-- **********************************
    **************************************
    ***********     Výsledky    *********
    **************************************
    ************************************** -->

          <v-col cols="12" md="8" class="mx-auto" v-if="isLoadingResults && !isRace0 && !results.length == []">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-col>

          <v-tabs-window-item value="results" v-if="!isLoadingResults && results.length > 0 && !isRace0">

            <!-- <v-col cols="12" md="3">
              <v-btn color="primary" @click="toggleStartlistViewMode">
                {{ startlistViewMode === 'category' ? 'Seznam podle času' : 'Seznam podle kategorií' }}
              </v-btn>
            </v-col> -->

            <v-row justify="center">
              <v-col cols="4" class="d-flex justify-center" v-if="authStore.isLoggedIn">
                <v-menu offset-y transition="slide-y-transition">
                  <template #activator="{ props }">
                    <v-btn icon v-bind="props" class="mx-2" color="primary" :title="$t('event.results_view.print_menu_title')">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="exportResultsTxt">
                      <v-list-item-title>{{ $t('event.startlist_view.txt') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportResultsSplitsTxt">
                      <v-list-item-title>{{ $t('event.results_view.txt_splits') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseApiUrl}/?type=json&name=race&race_id=${currentRaceId}&dl=1`" :download="`race_${currentRaceId}.json`">
                      <v-list-item-title>{{ $t('event_settings.results.export.json_ardf') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=xml&name=results&race_id=${currentRaceId}`">
                      <v-list-item-title>{{ $t('event_settings.results.export.xml_iof_ardf') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
               <v-col cols="4" class="d-flex justify-center" v-if="authStore.isLoggedIn">
                  <v-btn
                    icon
                    class="mx-2"
                    color="primary"
                    :title="$t('event.results')"
                    @click="printElementById('resultsContent', { title: $t('event.results'), headerLines: exportRaceHeaderLines })"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </v-col>
            </v-row>

            <!-- Navigační lišta kategorií -->
            <v-row class="w-100" justify="center">
              <v-col cols="12" class="ma-1 text-center">
                <v-btn
                  v-for="(categoryName, index) in Object.keys(sortedResultsByCategory)"
                  :key="index"
                  @click="scrollToCategory(categoryName)"
                  text
                  :color="getCategoryButtonColor(categoryName)"
                  class="ma-1"
                >
                  {{ categoryName }}
                </v-btn>
              </v-col>
            </v-row>

            <div id="resultsContent">

              <!-- Zobrazení podle katogorií -->
              <v-row>
                <v-col col="12" md="11" v-for="(categoryResults, categoryName) in sortedResultsByCategory" :key="categoryName" :id="`category-${categoryName.replace(/\s+/g, '-')}`" class="mx-auto px-2">
                  <v-row>
                    <v-card-title class="mb-2">{{ categoryName }} ({{ categoryResults.length }})</v-card-title>
                    <v-spacer></v-spacer>
                    <!-- Kontrolní body kategorie -->
                    <v-card-subtitle class="d-flex justify-center align-center">
                      <strong class="mr-1">{{ $t('event.results_view.controls_label') }}</strong>{{ categories.find(category => category.category_name === categoryName)?.category_control_points || "" }}
                    </v-card-subtitle>
                  </v-row>
                  <v-data-table
                    :headers="resultsHeadersFor(categoryName)"
                    :items="categoryResults"
                    :items-per-page="-1"
                    class="elevation-2"
                    @touchstart.stop
                    @touchmove.stop
                    :sort-by="resultsSortBy"
                    density="comfortable"
                    striped="even"
                    hover
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>{{ formatResultPlace(item.place, t, te) }}</td>
                        <td>
                          <router-link v-if="item.account_id" :to="'/ucet/' + item.account_id">{{ item.last_name }} {{ item.first_name}}</router-link>
                          <template v-else>{{ item.last_name }} {{ item.first_name }} <!--Pokud uživatel nemá v robisu účet, neukáže se na něj odkaz--></template>
                        </td>
                        <td>{{ item.competitor_index }}</td>
                        <td class="font-weight-bold">{{ item.run_time }} <span class="lost_time" v-if="item.lost_time">+{{ item.lost_time }}</span></td>
                        <td class="text-center">{{ item.punch_count }}</td>
                        <td :style="{
                              whiteSpace: display.mdAndUp ? 'normal' : 'nowrap',
                              flexWrap: display.mdAndUp ? 'wrap' : 'nowrap',
                              maxWidth: display.mdAndUp ? '220px' : 'auto'
                            }">
                          {{ (item.punches || []).slice(0, -1).map(punch => punch.code).join(", ") }}
                        </td>
                        <!-- Zobrazení punches -->
                        <td>
                          <div class="d-flex" :style="{
                              whiteSpace: display.mdAndUp ? 'normal' : 'nowrap',
                              flexWrap: display.mdAndUp ? 'wrap' : 'nowrap'
                            }">
                            <div
                              v-for="(punch, index) in item.punches" :key="index" class="mr-3" style="min-width: 52px; text-align: end" :class="{ 'text-orange-darken-3': ['AP', 'DP'].includes((punch.punch_status || '').toUpperCase()) }">
                              <div><b>{{ punch.code }}</b> {{ punch.split_time }}</div>
                              <div class="text-muted" style="text-align: right;">{{ punch.cumulative_time }}</div>
                            </div>
                          </div>
                          </td>
                          <td class="text-center">{{ item.result_vt }}</td>
                          <td class="text-center" v-if="isRankingCategory(categoryName)">{{ item.ranking_points }}</td>
                      </tr>
                    </template>
                    <template v-slot:bottom></template>
                  </v-data-table>
                </v-col>
              </v-row>
            </div>

          </v-tabs-window-item> 

        </v-window>
      </v-card-text>


    </v-card>
    
  </v-container>

  <!-- Tlačítko pro scrollování zpět nahoru -->
  <ScrollTopButton />

</template>




<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';
import { useRoute, useRouter } from 'vue-router';
import { useDateTimeFormat } from '../composables/useDateTimeFormat.js';
import { useDisplay } from 'vuetify';
import ScrollTopButton from '@/components/shared/ScrollTopButton.vue';
import EventPageLocationMap from '@/components/EventPageLocationMap.vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import PaymentTable from '@/components/shared/PaymentTable.vue';
import { printElementById } from '@/utils/print.js';
import { exportToTxt } from '@/utils/exportTxt.js';
import { exportToTxtSplits } from '@/utils/exportTxtSplits.js';
import EventPageAbsences from '@/components/EventPageAbsences.vue';
import EventPageAbsencesListAll from '@/components/EventPageAbsencesListAll.vue';
import { EVENT_TYPE_DICT, RACE_LEVEL_DICT, RACE_TYPE_DICT } from '@/components/const/enums.js'
import { useI18n } from 'vue-i18n'
import { formatResultPlace } from '@/composables/useResultPlaceDisplay'
import { buildGoogleCalendarUrlForEvent } from '@/utils/addToGoogleCalendar.js';


const { t, te } = useI18n()
const googleCalendarUrl = () => buildGoogleCalendarUrlForEvent(event.value, BaseUrl.value);
const snackbar = useSnackbarStore()
const display = ref(useDisplay());
const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();
const { formatDate, formatDateTime } = useDateTimeFormat();
// const isLoadingEvent = ref(true);
const BaseUrl = ref(process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, '').replace(/\/api\/?$/, '')); // Odstraní "api/" a nadbytečná lomítka
const BaseApiUrl = ref(process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, '')); // Odstraní pouze nadbytečná lomítka na konci
const event = ref({});
const races = ref([]);
const race0 = ref({});
const currentRaceId = ref(race0.value.id); // Zde uchováváme aktuálně vybrané ID závodu
const files = ref([]);
const entries = ref([]);
const main = ref('event');  // Přidáno pro inicializaci na první záložku main části
const second = ref('automodule');
const fromUrlTab = ref(false); // flag, zda jsme záložku načetli z URL – abychom ji nepřepisovali při automatické aktualizaci
const errorMessage = ref('');
const userHasEntry = ref(false);
const entriesByCategory = ref({});
const loadingDelegateReport = ref(false);

function downloadDelegateReport() {
  loadingDelegateReport.value = true;
  window.addEventListener(
    'focus',
    () => {
      loadingDelegateReport.value = false;
    },
    { once: true }
  );
}

const currentRace = computed(() => {
  const id = Number(currentRaceId.value);
  if (race0.value && Number(race0.value.id) === id) return race0.value;
  return races.value.find(r => Number(r.id) === id) || null;
});

const exportRaceHeaderLines = computed(() => {
  const r = currentRace.value;
  if (!r) return [];
  const en = event.value?.event_name || '';
  const rn = r.race_name || '';
  const title = [en, rn].filter(Boolean).join(' - ');
  const d = r.race_date ? formatDate(r.race_date) : '';
  return [title, d].filter(Boolean);
});

const exportStartlistTxt = () => {
  exportToTxt('startlistContent', 'startlist.txt', '\t', exportRaceHeaderLines.value);
};

const exportResultsTxt = () => {
  exportToTxt('resultsContent', 'resultst.txt', '\t', exportRaceHeaderLines.value);
};

const exportResultsSplitsTxt = () => {
  exportToTxtSplits('resultsContent', 'results-splits.txt', '\t', exportRaceHeaderLines.value);
};
const isRepreOrScm = computed(() => {
  const et = (event.value?.event_type || '').toLowerCase()
  return et === 'repre' || et === 'scm'
})
const categoryEntriesHeaders = computed(() => {
  const headers = [
    { title: t('event.entries_view.headers_name'), key: 'last_name' },
  ]

  if (isRepreOrScm.value) {
    headers.push({
      title: t('event.entries_view.headers_connected_with'),
      key: 'connected_with',
      sortable: false,
      width: '60px',
    })
  }

  headers.push(
    { title: t('event.entries_view.headers_index'), key: 'competitor_index', width: '80px' },
    { title: t('event.entries_view.headers_si'), key: 'si_number', width: '120px' },
  )

  return headers
});

const ClubEntriesHeaders = ref([
  { title: t('event.entries_view.headers_name'), key: 'last_name' },
  { title: t('event.entries_view.headers_category_short'), key: 'category_name', width: '80px' },
  { title: t('event.entries_view.headers_index'), key: 'competitor_index', width: '80px' },
  { title: t('event.entries_view.headers_si'), key: 'si_number', width: '120px' },
]);


// Přidání sloupců pro jednotlivé etapy (races) dynamicky
const updateHeadersWithRaces = (races) => {
  races.forEach((race, index) => {
    const newHeader = { title: `E${index + 1}`, key: `race_${race.id}`, width: '50px', sortable: false };
    categoryEntriesHeaders.value.push(newHeader);  // Přidání pro hlavní tabulku (podle kategorií)
    ClubEntriesHeaders.value.push(newHeader);  // Přidání pro klubovou tabulku
  });
};



const EntrySortByName = [{key: 'last_name', order: 'asc'}]; // Klíč pro řazení
const EntrySortByCategory = [{key: 'category_name', order: 'asc'}]; // Klíč pro řazení



// Oprávnění organizátora, závisí na tom, jestli je organizátor ve stejném klubu jako event nebo je editor
const isOrganizer = computed(() => {
  // Převod Proxy objektu na běžné pole pro jednoduchý přístup
  const isRoleOrganizer = authStore.isOrganizer(Number(event.value.club));
  // Podmínky pro editora
  const editorsArray = event.value.editors || [];
  const isUserEditor = editorsArray.includes(Number(authStore.userID));
  const isAuthor = Number(event.value.author) === Number(authStore.userID);

  // Oprávnění pro organizátora nebo když je editors prázdné
  console.log('Is Organizer:', isRoleOrganizer, 'Is User Editor:', isUserEditor);
  return isAuthor || isUserEditor || (editorsArray.length === 0 && isRoleOrganizer); // user je editor nebo pokud nejsou editoři, je organizátor
});

// Oprávnění správce oddílu
const isClubManager = computed(() => authStore.isClubManager());

// Vytvořeí isRace0 pro zobrazování některých záložek pouze na stránce o eventu
const isRace0 = computed(() => {
  return currentRaceId.value === race0.value.id;
});

// Filtrování souborů pro zobrazení pouze odkazů
const filesWithLinks = computed(() => files.value.filter(file => {
  // Vrátí true, pokud je `file.url` neprázdné a zároveň `file.location` chybí nebo je null
  return file.url && file.url.trim().length > 0 && !file.location;
}));

// Filtrování souborů pro zobrazení pouze souborů
const filesWithLocation = computed(() => files.value.filter(file => {
  // Vrátí true, pokud `file.location` není prázdné
  return file.location && (!file.url || file.url.trim().length === 0);
}));

// seřazení přihlášených závodníků podle kategorií a podle abecedy
const sortedEntriesByCategory = computed(() => {
  // Získání klíčů (názvů kategorií) a jejich seřazení
  const sortedCategoryNames = Object.keys(entriesByCategory.value).sort();
  // Vytvoření nového objektu, kde klíče jsou seřazené názvy kategorií
  const sortedEntries = {};
  sortedCategoryNames.forEach(categoryName => {
    sortedEntries[categoryName] = entriesByCategory.value[categoryName];
  });
  return sortedEntries;
});

// logika pro zobrazení správného deadline data
const currentDeadline = computed(() => {
  const now = new Date();
  const deadline1 = new Date(race0.value.entry_deadline_1);
  const deadline2 = new Date(race0.value.entry_deadline_2);

  if (now > deadline1) {
    return now > deadline2 ? t('event.entry_is_over') : formatDateTime(race0.value.entry_deadline_2);
  } else {
    return formatDateTime(race0.value.entry_deadline_1);
  }
});

const deadlineTerm = computed(() => {
  const now = new Date();
  const deadline1 = new Date(race0.value.entry_deadline_1);
  return now > deadline1 ? t('event.entry_deadline2_label') : t('event.entry_deadline1_label');
});

const isDeadlinePassed = computed(() => {
  const now = new Date();
  const deadline1 = new Date(race0.value.entry_deadline_1);
  const deadline2 = new Date(race0.value.entry_deadline_2);
  // Kontrola, zda aktuální čas je po druhém deadline
  // a také kontrola, že druhý deadline je po prvním deadline (což je logické a zároveň zajišťuje, že oba termíny jsou prošlé)
  return now > deadline2 && now > deadline1;
});

// Zobrazení upozornění na editaci ve 2. termínu přihlášek
const hasSecondDeadline = computed(() => !!race0.value?.entry_deadline_2);
const isFirstTermActive = computed(() => {
  const now = new Date();
  const d1 = race0.value?.entry_deadline_1 ? new Date(race0.value.entry_deadline_1) : null;
  if (!d1) return false;
  return now <= d1; // 1. termín běží do včetně d1
});
const showNoEditNotice = computed(() =>
  hasSecondDeadline.value && isFirstTermActive.value
);


 // Sledujte změnu v aktuálně vybrané záložce a mění Race ID
watch(main, (newValue) => {
  if (newValue === 'event' && race0.value && race0.value.id) {
    currentRaceId.value = race0.value.id;
  }
});


// Kromě toho můžeš mít watcher, který po změně v-modelech (currentRaceId a second)
// aktualizuje URL s trailing slash
watch([currentRaceId, second], ([newRaceId, newTab]) => {
  // Přidá trailing slash, pokud ještě chybí
  const newPath = route.path.endsWith('/') ? route.path : `${route.path}/`;
  router.replace({
    path: newPath,
    query: { race: newRaceId, tab: newTab }
  });
});


onMounted(async () => {
  await loadEventAndRacesData(); // Načtení etap spojených s eventem
  // Pokud máme v URL query parametr 'race', nastavíme currentRaceId a hlavní záložku
  if (route.query.race) {
    const raceParam = Number(route.query.race);
    currentRaceId.value = raceParam;
    // Pokud se jedná o první závod (race0), nastavíme hlavní záložku na 'event'
    if (race0.value && raceParam === race0.value.id) {
      main.value = 'event';
    } else {
      main.value = `race-${raceParam}`;
    }
  } else if (!currentRaceId.value && race0.value?.id) {
    currentRaceId.value = race0.value.id; // Výchozí nastavení, pokud není parametr v URL
  }
  // fetchStartlist(currentRaceId.value); // načtení startovek
  updateHeadersWithRaces(races.value); // Aktualizace hlaviček tabulky
  fetchAutomodules(); // načtení automodulu

  // Nastavení sekundární záložky z query nebo automaticky podle dostupných dat
  if (route.query.tab) {
    second.value = route.query.tab;
    fromUrlTab.value = true;
  } else {
    updateSecondTab();
  }

  fetchPayments();

});


// nastavení podle čeho se má zobrazit aktivní záložka v soutěži 
const updateSecondTab = () => {
  console.log(`Entries: ${entries.value.length}, Startlist: ${startlist.value.length}, Results: ${results.value.length}`);

  if (results.value.length > 0) {
    second.value = 'results';
  } else if (startlist.value.length > 0) {
    second.value = 'startlist';
  } else if (entries.value.length > 0) {
    second.value = 'entries';
  } else {
    second.value = 'automodule';
  }
};


async function loadEventAndRacesData() {
  const eventId = route.params.id; // Předpokládá se získání ID eventu z URL
  try {
    const response = await apiClient.get(`event/?event_id=${eventId}`);
    event.value = response.data;
    // Seřadit závody podle ID
    const sortedRaces = response.data.races.sort((a, b) => a.id - b.id);
    // uloží hodoty pro první race0
    race0.value = sortedRaces.length > 0 ? sortedRaces[0] : null;
    // Odstranit první závod (s nejnižším ID)
    const racesWithoutFirst = sortedRaces.slice(1);
    // Uložit upravené závody do races v pořadí podle ryce_date a race_start
    races.value = racesWithoutFirst.sort((a, b) => {
      if (a.race_date < b.race_date) return -1;
      if (a.race_date > b.race_date) return 1;
      if (a.race_start < b.race_start) return -1;
      return a.race_start > b.race_start ? 1 : 0;
    });
    // Po vytvoření race0 se toto id přenese do fetchCategories atd., aby se kategorie race0 načetli při otevření nastavení, když je vybraný Event
    // Načtení souborů a přihlášek pro Race0
    if (race0.value && race0.value.id) {
      files.value = race0.value.files;
      await fetchEntries(race0.value.id);
    }
  } catch (error) {
    console.error("There was an error fetching the event and races data:", error);
  // } finally {
  //   isLoadingEvent.value = false; 
  }
}

const isLoadingEntries = ref(false);
const clubIds = computed(() => authStore.rolesByIndex.map(r => Number(r.club)))

async function fetchEntries() {
  const eventId = route.params.id;
  isLoadingEntries.value = true;
  try {
    const response = await apiClient.get(`entries/?event_id=${eventId}`);
    entries.value = response.data;
    // filtrování entries pro automodul
    filteredEntries.value = entries.value.filter(entry => clubIds.value.includes(entry.competitor_club));
    processEntries(entries.value);
    checkUserEntry(); // Zavolejte novou metodu po načtení a zpracování přihlášek
    filterEntries(); // Filtrování entries po načtení přihlášek
  } catch (error) {
    console.error("Nepodařilo se načíst přihlášky:", error);
    entries.value = []; // Resetování pole přihlášek v případě chyby

  } finally {
    isLoadingEntries.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }
}

const viewMode = ref('category');

const toggleViewMode = () => {
  viewMode.value = viewMode.value === 'category' ? 'club' : 'category';
};

// Předpokládejme, že tato metoda je volána po načtení dat příhlášek z API
function processEntries(entriesData) {
  entriesByCategory.value = entriesData.reduce((acc, entry) => {
    const categoryName = entry.category_name || t('event.entries_view.has_not_category');
    acc[categoryName] = acc[categoryName] || [];
    
    // Pro každý entry, vytvořte samostatný objekt obsahující kategorie pro různé závody
    const raceCategories = {};
    entry.entry_race_data.forEach(race => {
      raceCategories[`race_${race.race_id}`] = race.category_name;
    });

    // Uložte do položky závodníka informace o kategoriích pro jednotlivé závody
    entry.raceCategories = raceCategories;

    acc[categoryName].push(entry);
    return acc;
  }, {});
}


const sortedEntriesByClub = computed(() => {
  const sortedClubEntries = {};

  entries.value.forEach(entry => {
    const clubName = entry.competitor_index ? entry.competitor_index.substring(0, 3).trim() : t('event.entries_view.noreg_short'); // Pokud není oddíl, použije se "NEREG"; // Předpokládám, že zkratka klubu je prvních 3 znaky indexu
    if (!sortedClubEntries[clubName]) {
      sortedClubEntries[clubName] = [];
    }
    sortedClubEntries[clubName].push(entry);
  });

  // Seřazení klubů podle abecedy
  const sortedKeys = Object.keys(sortedClubEntries).sort();

  // Vytvoření nového objektu s řazenými kluby
  const sortedResult = {};
  sortedKeys.forEach(key => {
    sortedResult[key] = sortedClubEntries[key];
  });

  return sortedResult;
});


watch(entries, (newEntries) => {
  second.value = newEntries.length > 0 ? 'entries' : 'automodule';
}, { immediate: true });

function checkUserEntry() {
  const userEntry = entries.value.find(entry => entry.account_id === Number(authStore.userID ));
  
  userHasEntry.value = !!userEntry;
  if (userEntry) {
        // Uživatel má již přihlášku, aktualizujte UI odpovídajícím způsobem
        console.log("Uživatel je již přihlášen do závodu.");
        // Zde můžete například nastavit nějakou data property, která řídí, co se zobrazí uživateli
      } else {
        // Uživatel nemá přihlášku, zobrazte možnost přihlásit se
        console.log("Uživatel není přihlášen do závodu.");
      }
  }


// watcher na sledování v-model záložek pro event a races a následné načtení dat z api
watch(main, async (newTab) => {
  console.log(`Aktuální záložka: ${newTab}`);
  if (newTab === 'event') {
    currentRaceId.value = race0.value.id;
    // Vymazání startlistu a výsledků, protože pro event je nechceme zobrazovat
    startlist.value = [];
    isLoadingStartlist.value = false;
    results.value = [];
    files.value = race0.value.files;

    console.log('Načítám data pro hlavní záložku.');

  } else if (newTab.startsWith('race-')) {
    const raceId = Number(newTab.split('-')[1]); // Získání race ID ze záložky
    currentRaceId.value = raceId;

    // Najdeme závod
    if (race0.value && race0.value.id === raceId) {
      files.value = race0.value.files || [];
    } else {
      const foundRace = races.value.find(r => r.id === raceId);
      files.value = foundRace ? foundRace.files : [];
    }
  
    await fetchResults(raceId);
    await fetchStartlist(raceId);
  }

  // Pokud záložku nezadáme z URL, pak provedeme automatické nastavení sekundární záložky
  if (!fromUrlTab.value) {
    updateSecondTab(); // načtení aktivní záložky podle dostupných dat ve všech případech
  }

});




// Funkce pro konverzi času na minuty pro limit
function formatTimeInMinutes(time) {
  if (!time) return '';
  const parts = time.split(':');
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  return hours * 60 + minutes;
}



// Kopírování emailů přihlášených uživatelů na soutěž pro správce oddílu
function copyEmails() {
  const emails = entries.value
    .filter(entry =>
      clubIds.value.includes(entry.competitor_club)
      && entry.email
      && !entry.email.includes('rob-is.cz')
    )
    .map(entry => entry.email);

  if (emails.length) {
    navigator.clipboard.writeText(emails.join(', '))
      .then(() => snackbar.success(t('event.entries_view.snackbar_emails_copied')))
      .catch(console.error);
  } else {
    snackbar.success(t('event.entries_view.snackbar_no_emails'));
  }
}
// scrolování po kliknutí na příslušnou kategorii
function scrollToCategory(categoryName) {
  const categoryId = `category-${categoryName.replace(/\s+/g, '-')}`;
  const categoryElement = document.getElementById(categoryId);
  if (categoryElement) {
    const yOffset = -50; 
    const y = categoryElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

function scrollToStartlistCategory(categoryName) {
  const categoryId = `startlist-category-${categoryName.replace(/\s+/g, '-')}`;
  const categoryElement = document.getElementById(categoryId);
  if (categoryElement) {
    const yOffset = -60;
    const y = categoryElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

// Namapování kategorií s atributy pro správné zobrazení barev tlačítek
const categoryAttributesMap = computed(() => {
  const map = {};
  event.value.races.forEach(race => {
    race.categories.forEach(category => {
      map[category.category_name] = {
        gender: category.category_gender,
        option: category.option
      };
    });
  });
  return map;
});




function getCategoryButtonColor(categoryName) {
  const attributes = categoryAttributesMap.value[categoryName];
  // Zkontroluje, zda je uživatel přihlášen v této kategorii
  const isUserInCategory = entries.value.some(
    entry => entry.category_name === categoryName && entry.account_id === Number(authStore.userID)
  );

  if (isUserInCategory) {
    return 'green'; // Kategorie, kde je uživatel přihlášen
  }
  if (!attributes) {
    return 'grey'; // Výchozí barva pro neznámé kategorie
  }
  if (attributes.option === 'OTHERS') {
    return 'grey'; // Pokud je raceType "OTHERS"
  }
  if (attributes.option === 'ORG') {
    return 'grey'; // Pokud je raceType "ORG"
  }

  if (attributes.gender === 'F') {
    return 'red'; // Ženské kategorie
  } else if (attributes.gender === 'M') {
    return 'blue'; // Mužské kategorie
  }
  return 'grey'; // Výchozí barva
}


function scrollToClub(clubName) {
  const clubId = `club-${clubName.replace(/\s+/g, '-')}`;
  const clubElement = document.getElementById(clubId);
  if (clubElement) {
    const yOffset = -50; // Upravit odsazení podle potřeby
    const y = clubElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}



///////////////////////////////////////
//////                        /////////
//////      Automodul         /////////
//////                        /////////
///////////////////////////////////////



const errorMessageAutomodule = ref('');

const allAutomoduleLoading = ref(true);


const title = ref('');
const maxEntries = ref(5);
const automodules = ref([]);

const dialogCreateAutomodule = ref(false);

function openCreateAutomoduleDialog() {
  dialogCreateAutomodule.value = true;
}

const isFormValid = computed(() => {
  return title.value.trim() !== '' && maxEntries.value > 0 && maxEntries.value <= 50;
});

const showAllModules = ref(false);

async function fetchAutomodules(all = false) {
  allAutomoduleLoading.value = true;  // Začneme s aktivovaným loadingem
  try {
    const eventId = route.params.id;
    const response = await apiClient.get(`automodule/?event_id=${eventId}&all=${all}`);
    automodules.value = response.data;
    automodules.value.forEach(automodule => {
      automodule.editing = false;
      automodule.entries.forEach(entry => {
        entry.editing = false;
      });
    });
    filterEntries(); // Filtrování entries po načtení automodulu
  } catch (error) {
    console.error('Nastala chyba při získávání automodule:', error);

  } finally {
    allAutomoduleLoading.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }
}

// Přepínání zobrazení dopravy 
const toggleShowAll = () => {
  showAllModules.value = !showAllModules.value; // Přepnutí hodnoty
  fetchAutomodules(showAllModules.value); // Získání dat
};


// Výpočet a dosazení délky pro name u autoodule entry tak, aby se všechny řádky se jménem roztáhly stejně
const maxEntryNameWidth = ref(0);
watch(automodules, (newVal) => {
  maxEntryNameWidth.value = Math.max(...newVal.flatMap(automodule => automodule.entries.map(entry => entry.name ? entry.name.length * 8 : 80))) + 5;
}, { deep: true });


const canEditAutomodule = (automodule) => {
  const userIsClubManager = authStore.isClubManager(automodule.club_id);
  const userIsDriver = automodule.entries.some(entry => entry.driver && `${entry.name}` === `${authStore.last_name} ${authStore.firstName}`);
  const userIsCreator = automodule.created_id !== undefined && Number(authStore.userID) === Number(automodule.created_id);
  return userIsClubManager || userIsDriver || userIsCreator;
};

const canEditEntry = (entry, automodule) => {
  const userIsClubManager = authStore.isClubManager(entry.club_shortcut) || authStore.isClubManager(automodule.club_id);
  const userIsDriver = automodule.entries.some(entry => entry.driver && `${entry.name}` === `${authStore.last_name} ${authStore.firstName}`);
  const userIsEntry = entry.name === `${authStore.last_name} ${authStore.firstName}`;
  const userIsCreator = automodule.created_id !== undefined && Number(authStore.userID) === Number(automodule.created_id);
  const userIsAuthor = entry.author_id !== undefined && Number(authStore.userID) === Number(entry.author_id);
  return userIsClubManager || userIsDriver || userIsEntry || userIsCreator || userIsAuthor || !entry.name;
};


async function submitAutomodule() {
  try {
    const eventId = route.params.id;
    await apiClient.post(`automodule/?event_id=${eventId}`, {
      title: title.value,
      max_entries: maxEntries.value,
    });
    snackbar.success(t('event.automodule.snackbar_create_success'));
    errorMessageAutomodule.value = '';
    title.value = '';
    maxEntries.value = 5;
    dialogCreateAutomodule.value = false; // Zavřít dialog po úspěšném vytvoření
    fetchAutomodules();
  } catch (error) {
    errorMessageAutomodule.value = t('event.automodule.error_create');  
  }
}

const isEditing = computed(() => {
  return automodules.value.some(automodule => automodule.editing) || automodules.value.some(automodule => automodule.entries.some(entry => entry.editing));
});

// Zobrazení hypertextového odkazu v poznámce automodulu a v titulku
const linkify = (text = '') => {
  return text.replace(
    /(https?:\/\/[^\s]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
  )
}

function toggleEditAutomodule(automodule) {
  automodules.value.forEach(am => {
    if (am !== automodule) {
      am.editing = false;
    }
  });
  automodule.editing = !automodule.editing;
  if (!automodule.editing) {
    updateAutomodule(automodule);
  }
}

// předvyplnění name přihlášeného uživatele z pinia store
const userFullName = computed(() => {
  return `${authStore.last_name} ${authStore.firstName}`;
});

// kliknutí na editaci uživatele
function toggleEditEntry(entry, automodule) {
  automodules.value.forEach(am => {
    am.entries.forEach(e => {
      if (e !== entry) {
        e.editing = false;
      }
    });
  });

  // pokud právě vstupujeme do edit módu, uložíme zálohu
  if (!entry.editing) {
    entry._backup = {
      name: entry.name,
      notice: entry.notice,
    };
  }

  entry.editing = !entry.editing;
  if (entry.editing && !entry.name) {
    entry.name = userFullName.value; // Předvyplnění pole name
  }
  if (!entry.editing) {
    updateAutomodule(automodule);
  }
}


function cancelEditEntry(entry) {
  if (entry._backup) {
    entry.name   = entry._backup.name;
    entry.notice = entry._backup.notice;
    // případně další pole…
    delete entry._backup;
  }
  entry.editing = false;
}


function toggleWay(entry) {
  if (entry.way === '1') {
    entry.way = '2';
  } else if (entry.way === '2') {
    entry.way = '3';
  } else {
    entry.way = '2';
  }
}

function getTooltipText(way) {
      if (way === '2') {
        return t('event.automodule.way_tooltip.there');
      } else if (way === '3') {
        return t('event.automodule.way_tooltip.back');
      } else {
        return t('event.automodule.way_tooltip.both');
      }
    }

function getIconClass(way) {
  if (way === '1') {
    return 'mdi-arrow-left-right';
  } else if (way === '2') {
    return 'mdi-arrow-right';
  } else {
    return 'mdi-arrow-left';
  }
}


// TODO pokud jsou v přihlášených 2 a více lidí se stejným jménem a příjmením, tak to špatně spáruje přihlášku na etapu s přihláškou do automodule.

// const automoduleSuggestedEntries = computed(() =>
//   filteredEntries.value.map(e => ({
//     id:         e.id,
//     last_name:  e.last_name,
//     first_name: e.first_name,
//     text:       `${e.last_name} ${e.first_name}`
//   }))
// )

// <v-combobox
//   …
//   :items="automoduleSuggestedEntries"
//   item-value="id"
//   item-title="text"
//   return-object
//   @update:modelValue="val => onSelectEntry(entry, val)"
// >
// </v-combobox>

// function onSelectEntry(entry, val) {
//   if (val && typeof val === 'object') {
//     entry.entry_id = val.id
//     entry.name     = `${val.last_name} ${val.first_name}`
//   } else {
//     entry.entry_id = null
//     entry.name     = val || ""
//   }
// }


async function updateAutomodule(automodule) {
  try {
// Připravit data pro odeslání, zahrnout entry_id a email z entry
  const entriesData = automodule.entries.map(entry => {
      const raceEntry = entries.value.find(e => `${e.last_name} ${e.first_name}` === entry.name);
      return {
        id: entry.id,
        name: entry.name || "",
        notice: entry.notice,
        email: entry.email,
        driver: entry.driver,
        club_shortcut: entry.club_shortcut,
        timestamp: entry.timestamp,
        way: entry.way,
        entry: raceEntry ? raceEntry.id : null // entry se získá z příhlášky
      };
    });
    const automoduleData = {
      ...automodule, // zahrnout všechna pole z automodule a převést "" na null
      km_there: automodule.km_there === "" ? null : automodule.km_there,
      km_back: automodule.km_back === "" ? null : automodule.km_back,
      entries: entriesData // Přidat entries data
    };

    await apiClient.put(`automodule/`, automoduleData);

    snackbar.success(t('event.automodule.snackbar_update_success'));
    errorMessageAutomodule.value = '';

  } catch (error) {
      if (error.response && error.response.status === 409) {
        errorMessageAutomodule.value = error.response.data.error || t('event.automodule.error_update_conflict');
      } else {
        errorMessageAutomodule.value = t('event.automodule.error_update');
      }
    } finally {
    fetchAutomodules(showAllModules.value); // Načte aktuální data
  }
}



async function confirmDeleteAutomodule(automodule) {
  automodule.dialogDeleteAutomodule = false;
  try {
    await deleteAutomodule(automodule.id);
    snackbar.success(t('event.automodule.snackbar_delete_success'));
    fetchAutomodules();
  } catch (error) {
    errorMessageAutomodule.value = t('event.automodule.error_delete');
  }
}

async function deleteAutomodule(automoduleId) {
  await apiClient.delete(`automodule/?automodule_id=${automoduleId}`);
}

const filteredEntries = ref([]);

function filterEntries() {
  // 1) Sestavíme mapu {raceEntryId: Set(způsobů)}:
  const entriesWithWay = {};
  automodules.value.forEach(am => {
    am.entries.forEach(e => {
      const rid = e.entry_id; 
      if (!rid) return; // ignorujeme záznamy bez entry_id
      if (!entriesWithWay[rid]) {
        entriesWithWay[rid] = new Set();
      }
      entriesWithWay[rid].add(e.way);
    });
  });

  // 2) Seznam všech club ID z rolí uživatele:
  const clubIds = authStore.rolesByIndex.map(r => Number(r.club));

  // 3) Pokud showAllModules, ber všechny entries, jinak jen z tvého klubu:
  const clubEntries = showAllModules.value
    ? entries.value
    : entries.value.filter(e => clubIds.includes(e.competitor_club));

  // 4) Filtrovat ty, kteří NEMAJÍ splněnou dopravu „tam i zpět“:
  filteredEntries.value = clubEntries.filter(entry => {
    const waysSet = entriesWithWay[entry.id] || new Set();
    const hasFullRoundTrip = waysSet.has('1') || (waysSet.has('2') && waysSet.has('3'));
    return !hasFullRoundTrip;
  });

  // 5) Nastavit wayNotice jen pokud chybí právě jedna cesta:
  filteredEntries.value.forEach(entry => {
    const waysSet = entriesWithWay[entry.id] || new Set();
    const has2 = waysSet.has('2');
    const has3 = waysSet.has('3');

    if (has2 && !has3) {
      entry.wayNotice = t('event.automodule.way_tooltip.way_back');
    } else if (has3 && !has2) {
      entry.wayNotice = t('event.automodule.way_tooltip.way_there');
    } else {
      entry.wayNotice = ""; // buď chybí obě, nebo má obousměrnou/kompletní → žádná poznámka
    }
  });
}





function isEditingEntryOtherThan(currentEntry) {
  return automodules.value.some(automodule =>
    automodule.entries.some(entry => entry.editing && entry !== currentEntry)
  );
}


// Našeptávač pro automodul





/////////////////////////////////////////
//////                          /////////
//////       Přehled plateb     /////////
//////                          /////////
/////////////////////////////////////////



const payments = ref ({});

async function fetchPayments() {
  const eventId = route.params.id;
  try {
    const response = await apiClient.get(`payment/?event_id=${eventId}`);
    payments.value = response.data;

  } catch (error) {
    console.error("Nepodařilo se načíst přihlášky:", error);
    payments.value = []; // Resetování pole přihlášek v případě chyby

  } 
}

const isDownloadingFile = ref(false);

function downloadFile() {
  isDownloadingFile.value = true

  // jakmile se vrátíte zpět do okna po otevření dialogu "uložit soubor",
  // spinner se vypne
  window.addEventListener(
    'focus',
    () => {
      isDownloadingFile.value = false
    },
    { once: true }
  )
}

///////////////////////////////////////
//////                        /////////
//////       Startovky        /////////
//////                        /////////
///////////////////////////////////////


const startlist = ref([]);

const startlistViewMode = ref('category');

const toggleStartlistViewMode = () => {
  startlistViewMode.value = startlistViewMode.value === 'category' ? 'time' : 'category';
};

// Seřazení startovní listiny podle kategorií
const sortedStartlistByCategory = computed(() => {
  const sortedCategoryEntries = {};
  startlist.value.forEach(item => {
    if (!sortedCategoryEntries[item.category_name]) {
      sortedCategoryEntries[item.category_name] = [];
    }
    sortedCategoryEntries[item.category_name].push(item);
  });
  return Object.fromEntries(
    Object.entries(sortedCategoryEntries).sort(([a], [b]) =>
      a.localeCompare(b, 'cs', { numeric: true })
    )
  );
});


// Seřazení startovní listiny podle startovních časů
const sortedStartlistByTime = computed(() => {
  const sortedTimeEntries = {};
  const sortedList = [...startlist.value].sort((a, b) => {
    if (a.competitor_start_time < b.competitor_start_time) return -1;
    if (a.competitor_start_time > b.competitor_start_time) return 1;
    return 0;
  });

  sortedList.forEach(item => {
    const formattedTime = item.competitor_start_time;
    if (!sortedTimeEntries[formattedTime]) {
      sortedTimeEntries[formattedTime] = [];
    }
    sortedTimeEntries[formattedTime].push(item);
  });

  return sortedTimeEntries;
});


const GetStartlistHeaders = ref([

      { title: t('event.startlist_view.headers_start_time'), value: 'competitor_start_time', sortable: true },
      { title: t('event.startlist_view.headers_full_name'), value: 'full_name', sortable: true },
      { title: t('event.startlist_view.headers_start_number'), value: 'start_number', sortable: false, align: 'center', width: '70px' },
      { title: t('event.startlist_view.headers_si'), value: 'si_number', sortable: true },
      { title: t('event.startlist_view.headers_club'), value: 'club_shortcut', sortable: true },
    ]);

const sortBy = [{key: 'competitor_start_time', order: 'asc'}];
const isLoadingStartlist = ref(true);

async function fetchStartlist(raceId) {
  isLoadingStartlist.value = true;
  try {
    const response = await apiClient.get(`/startlist/?race_id=${raceId}`);
    startlist.value = response.data
      .map(item => {
        return {
          ...item,
          full_name: `${item.last_name} ${item.first_name}`, // Spojení příjmení a jména do jednoho pole
          competitor_start_time: new Date(item.competitor_start_time),
        };
      })
      .sort((a, b) => { // Seřazení nejdříve podle category_name a poté podle start_time
        if (a.category_name < b.category_name) return -1;
        if (a.category_name > b.category_name) return 1;
        if (a.start_time < b.start_time) return -1;
        if (a.start_time > b.start_time) return 1;
        return 0;
      });
  } catch (error) {
    console.error('Chyba při načítání dat:', error);  
  } finally {
      isLoadingStartlist.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }
}


///////////////////////////////////////
//////                        /////////
//////       Výsledky         /////////
//////                        /////////
///////////////////////////////////////

const results = ref([]);
const resultsSortBy = [{key: 'sort_place', order: 'asc'}];


const GetResultsHeaders = ref([
  { title: t('event.results_view.headers_place'), value: "place", width: "40px", sortable: false },
  { title: t('event.results_view.headers_name_short'), value: "last_name", sortable: false },
  { title: t('event.results_view.headers_index'), value: "competitor_index", sortable: false },
  { title: t('event.results_view.headers_time'), value: "run_time", align: "start", sortable: false },
  { title: t('event.results_view.headers_fox'), value: "punch_count", width: "50px", align: "center", sortable: false },
  { title: t('event.results_view.headers_order'), value: "punch_codes", align: "start", sortable: false },
  { title: t('event.results_view.headers_splits'), value: "punches", sortable: false },
  { title: t('event.results_view.headers_vt'), value: "result_vt", width: "40px", sortable: false },
  { title: t('event.results_view.headers_ranking_points'), value: "ranking_points", width: "40px", sortable: false },


]);

// Zobrazení sloupce Ranking points jen pro kategorie M21 a W21
const isRankingCategory = (categoryName) => {
  const attrs = categoryAttributesMap.value[categoryName];
  return attrs && (attrs.option === 'M21' || attrs.option === 'W21' || attrs.option === 'M19' || attrs.option === 'W19');

};

const resultsHeadersFor = (categoryName) => {
  // nechat vše pro M21/W21, jinak bez ranking_points
  return isRankingCategory(categoryName)
    ? GetResultsHeaders.value
    : GetResultsHeaders.value.filter(h => h.value !== 'ranking_points');
};


// Rozdělení výsledků podle kategorií
const sortedResultsByCategory = computed(() => {
  const grouped = {};
  results.value.forEach((result) => {
    const categoryName = result.competitor_category_name || "Nezařazeni";
    if (!grouped[categoryName]) grouped[categoryName] = [];
    grouped[categoryName].push(result);
  });

  // Seřazení kategorií podle názvu
  return Object.fromEntries(Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b, 'cs', { numeric: true })));
});


const isLoadingResults = ref(true);
const categories = ref([]);

const fetchResults = async () => {
    isLoadingResults.value = true;
    try {
      const response = await apiClient.get(`/results/?race_id=${currentRaceId.value}`);
      categories.value = response.data.categories;
      results.value = response.data.results.map((result) => ({
      ...result,
      sort_place: result.place !== null ? result.place : Infinity, // Nahradíme null hodnoty za Infinity
    }));
    } catch (error) {
      console.error('Chyba při načítání dat:', error);
    } finally {
      isLoadingResults.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }


};

// Zkopírování URL odkazu
function copyPageUrl() {
  const base = window.location.origin;
  const url = `${base}/soutez/${event.value.id}/`; // bez query, s trailing slash
  navigator.clipboard.writeText(url)
    .then(() => snackbar.success(t('event_settings.stage.copy_url') || 'Odkaz zkopírován'))
    .catch(() => snackbar.error(t('general.copy_failed') || 'Nepodařilo se zkopírovat'));
}




</script>






<style scoped>

/* Kompaktní řádky u metadat události (race0) a u detailu etap — bez vlivu na exportní menu */
:deep(.event-page-race-meta-list .v-list-item) {
  min-height: 0;
}

/* Automodul: seznam míst v autě — méně svislého rozestupu */
:deep(.event-automodule-entry-list .v-list-item) {
  min-height: 36px;
}

/* zmenšení margin, aby se do okna vešel rám oken */
.v-row {
  margin:-10px;
}

.text-red {
  color: red;
}

.lost_time {
  color: gray;
  font-size: 11px;
  font-weight: lighter;
}

  :deep() table th + th { border-left:1px solid #dddddd; }
  :deep() table td + td { border-left:1px solid #dddddd; } 


  .grey--text {
  color: grey !important;
  opacity: 0.7;
}


.startlist-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.startlist-cell {
  flex: 1;
  text-align: left;
}

.startlist-cell:not(:last-child) {
  padding-right: 16px; /* Prostor mezi sloupci */
}


.startlist-header-row {
  display: flex;
  font-weight: bold;
}

.startlist-header-cell {
  flex: 1;
  padding: 8px;
}


</style>